const events = {
  landingAddToSlack: {
    category: 'Landing Page',
    action: 'Click',
    label: 'Landing Add to Slack',
  },
  landingAddToWebex: {
    category: 'Landing Page',
    action: 'Click',
    label: 'Landing Add to Webex',
  },
  FAQ: {
    category: 'Landing Page',
    action: 'Click',
    label: 'FAQ',
  },
  privacyPolicy: {
    category: 'Landing Page',
    action: 'Click',
    label: 'Privacy Policy',
  },
  contactUs: {
    category: 'Landing Page',
    action: 'Click',
    label: 'Contact us',
  },
  cast: {
    category: 'Dashboard Devices',
    action: 'Cast',
    label: 'Casted',
  },
  pair: {
    category: 'Dashboard Devices',
    action: 'Pair',
  },
  addFBSuccess: {
    category: 'Dashboard Facebook',
    action: 'Add Page',
  },
  addFBFail: {
    category: 'Dashboard Facebook',
    action: 'Add Page',
    label: 'No FB Added',
  },
  removeFB: {
    category: 'Dashboard Facebook',
    action: 'Remove page',
  },
  manageFB: {
    category: 'Dashboard Facebook',
    action: 'Manage page',
  },
  loginSlack: {
    category: 'Login Page',
    action: 'Click',
    label: 'Log in with Slack',
  },
  loginGoogle: {
    category: 'Login Page',
    action: 'Click',
    label: 'Log in with Google',
  },
  addSlack: {
    category: 'Dashboard Slack',
    action: 'Click',
    label: 'Add Slack',
  },
  removeSlack: {
    category: 'Dashboard Slack',
    action: 'Remove Slack',
  },
  loginWebex: {
    category: 'Login Page',
    action: 'Click',
    label: 'Log in with Webex',
  },
  addWebex: {
    category: 'Dashboard Webex',
    action: 'Click',
    label: 'Add Webex',
  },
  removeWebex: {
    category: 'Dashboard Webex',
    action: 'Remove Webex',
  },
};

export default events;



// WEBPACK FOOTER //
// ./src/services/ga_events.js